import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication or user data
  if (isLoading || (isAuthenticated && !user)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has required role - redirect immediately without rendering
  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.user_type)) {
    const redirectPath = user.user_type === 'admin' ? '/admin' : 
                        user.user_type === 'vendor' ? '/vendor' : '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  // Only render children if user has permission
  return children;
};

export default ProtectedRoute;
